import styled from 'styled-components';
import { getThemeProp } from 'theme';

/* eslint-disable-next-line import/prefer-default-export */
export const StyledContainer = styled.li`
  border-bottom: 1px solid ${getThemeProp('colors.altoGrey6')};
  cursor: pointer;
  position: relative;

  [class^='icon'] {
    color: ${getThemeProp('colors.seaBuckthornOrange')};
    display: flex;
    font-size: 15px;
    padding: 0 4px;

    &:hover {
      &:not([class*='rule']) {
        color: ${getThemeProp('colors.moodyBlue2')};
      }
    }
  }

  ${props =>
    props.isPreSelected &&
    ` 
           background-color: ${props.theme.colors.solitudeGrey};
    `}

  ${props =>
    props.isSelected &&
    `
       background-color: ${props.theme.colors.havelockBlue}
    `};

  ${props =>
    props.isGroup
      ? `
         background-color: inherit;
         border: none;
      `
      : ` 
        &:hover {
           background-color: ${props.theme.colors.solitudeGrey};
        }
      `}

  ${props =>
    props.isSelected &&
    !props.isGroup &&
    `
        &&&& {
            * {
                color: ${props.theme.colors.white} ;
              }
        }

        &:hover {
          background-color: ${props.theme.colors.havelockBlue}
        }
    `}
`;
